import React from 'react';
import { Sun, Moon } from 'lucide-react';

const ThemeToggle = ({ theme, onThemeChange }) => (
    <button
        onClick={() => onThemeChange(theme === 'tech' ? 'professional' : 'tech')}
        className={`fixed top-4 right-4 p-2 rounded-full 
      ${theme === 'tech' ? 'bg-green-400 text-black' : 'bg-blue-500 text-white'}
      transition-all duration-300
      z-[60]`}  // Added higher z-index
    >
        {theme === 'tech' ? <Sun size={24} /> : <Moon size={24} />}
    </button>
);

export default ThemeToggle;